module.exports = __webpack_public_path__ + "img/ChannelsHigh.59ea939c.svg";